/* Tassen-Seite: Preisrechner (Section "tm-preisrechner").
   Staffelpreise kommen aus data-tiers / data-tiers-2 / data-tiers-3 (JSON, aus den Blöcken der Section),
   je ein Satz pro Tassen-Tab. Logik: Der Stückpreis gilt für die gesamte Menge. Liegt die nächste Stufe
   in Summe günstiger (z. B. 49 vs. 50 Stück), erscheint ein Tipp.
   Schieberegler: stufenweise Skala – jeder Abschnitt zwischen zwei Preisstufen ist 100 Schritte breit,
   so liegen 10–100 Stück nicht auf 5 % des Reglers. Menge zusätzlich als Zahlenfeld. */
(function () {
  'use strict';

  function fmt(n) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function parseTiers(root, attr) {
    var t;
    try { t = JSON.parse(root.getAttribute(attr) || '[]'); } catch (e) { t = []; }
    return t;
  }

  function init(root) {
    var sets = {
      1: parseTiers(root, 'data-tiers'),
      2: parseTiers(root, 'data-tiers-2'),
      3: parseTiers(root, 'data-tiers-3')
    };
    var tiers = sets[1];
    if (!tiers.length) return;

    var range = root.querySelector('[data-tm-range]');
    if (!range) return;
    var qtyInput = root.querySelector('[data-tm-qty-input]');
    var qtyEls = root.querySelectorAll('[data-tm-qty]');
    var priceEl = root.querySelector('[data-tm-price]');
    var totalEl = root.querySelector('[data-tm-total]');
    var saveEl = root.querySelector('[data-tm-save]');
    var fillEl = root.querySelector('[data-tm-fill]');
    var tipEl = root.querySelector('[data-tm-tip]');
    var bars = root.querySelectorAll('[data-tm-bar]');
    var overNote = root.getAttribute('data-tm-over-note') || '';
    var overMax = false;
    var tabs = root.querySelectorAll('[data-tm-tab]');
    var min = tiers[0][0];
    var max = parseInt(range.getAttribute('data-tm-max'), 10) || tiers[tiers.length - 1][0];
    if (max < tiers[tiers.length - 1][0]) max = tiers[tiers.length - 1][0];

    /* Stützpunkte der Regler-Skala: alle Stufen, plus max_qty als letzter Punkt, wenn größer */
    var points = [];
    for (var i = 0; i < tiers.length; i++) points.push(tiers[i][0]);
    if (max > points[points.length - 1]) points.push(max);
    var segs = points.length - 1;
    range.min = 0;
    range.max = segs * 100;
    range.step = 1;

    function sliderToQty(v) {
      v = Math.min(Math.max(v, 0), segs * 100);
      var i = Math.min(Math.floor(v / 100), segs - 1);
      var frac = (v - i * 100) / 100;
      return Math.round(points[i] + frac * (points[i + 1] - points[i]));
    }
    function qtyToSlider(q) {
      if (q <= points[0]) return 0;
      if (q >= points[segs]) return segs * 100;
      for (var i = 0; i < segs; i++) {
        if (q >= points[i] && q < points[i + 1]) {
          return i * 100 + ((q - points[i]) / (points[i + 1] - points[i])) * 100;
        }
      }
      return segs * 100;
    }

    function priceFor(qty) {
      var cur = tiers[0];
      for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i][0]) cur = tiers[i]; }
      return cur;
    }

    /* Balken: Preis-Label und Höhe (als Anteil 0–1, die Pixel regelt das CSS – mobil kleiner) */
    function paintBars() {
      var pmin = Infinity, pmax = -Infinity;
      for (var i = 0; i < tiers.length; i++) { pmin = Math.min(pmin, tiers[i][1]); pmax = Math.max(pmax, tiers[i][1]); }
      var span = pmax - pmin;
      for (var b = 0; b < bars.length; b++) {
        var bq = parseInt(bars[b].getAttribute('data-tm-bar'), 10);
        var tier = null;
        for (var t = 0; t < tiers.length; t++) { if (tiers[t][0] === bq) tier = tiers[t]; }
        if (!tier) continue;
        var r = span > 0 ? Math.round(((tier[1] - pmin) / span) * 100) / 100 : 0.5;
        bars[b].style.setProperty('--tm-r', r);
        bars[b].textContent = fmt(tier[1]);
        bars[b].setAttribute('aria-label', 'Ab ' + bq.toLocaleString('de-DE') + ' Stück: ' + fmt(tier[1]) + ' pro Stück');
      }
    }

    function render(qty, source) {
      if (isNaN(qty)) qty = min;
      qty = Math.min(Math.max(qty, min), max);
      var cur = priceFor(qty);
      var price = cur[1];

      for (var q = 0; q < qtyEls.length; q++) qtyEls[q].textContent = qty.toLocaleString('de-DE');
      if (qtyInput && source !== 'input') qtyInput.value = qty;
      if (source !== 'range') range.value = Math.round(qtyToSlider(qty));
      range.setAttribute('aria-valuenow', qty);
      range.setAttribute('aria-valuetext', qty.toLocaleString('de-DE') + ' Stück');
      if (priceEl) priceEl.textContent = fmt(price);
      if (totalEl) totalEl.textContent = fmt(qty * price);

      var saving = Math.round((1 - price / tiers[0][1]) * 100);
      if (saveEl) { saveEl.textContent = '−' + saving + ' %'; saveEl.hidden = saving <= 0; }
      if (fillEl) fillEl.style.width = Math.round((qtyToSlider(qty) / (segs * 100)) * 100) + '%';

      for (var b = 0; b < bars.length; b++) {
        var bq = parseInt(bars[b].getAttribute('data-tm-bar'), 10);
        bars[b].classList.toggle('is-sel', bq === cur[0]);
        bars[b].classList.toggle('is-on', bq < cur[0]);
      }

      /* Tipp: Platz ist immer reserviert (Box bleibt gleich hoch), Text blendet nur ein/aus */
      var next = null;
      for (var n = 0; n < tiers.length; n++) { if (tiers[n][0] > qty) { next = tiers[n]; break; } }
      var showTip = !!(next && next[0] * next[1] < qty * price);
      /* Mehr als die Höchstmenge eingetippt → statt stillem Deckel der Hinweis aufs Angebot (im selben Platz wie der Tipp) */
      if (overMax && overNote) { showTip = true; }
      if (tipEl) {
        if (overMax && overNote) tipEl.textContent = overNote;
        else if (showTip) tipEl.textContent = 'Tipp: ' + next[0].toLocaleString('de-DE') + ' Stück kosten weniger (' + fmt(next[0] * next[1]) + ').';
        tipEl.classList.toggle('is-on', showTip);
        tipEl.setAttribute('aria-hidden', showTip ? 'false' : 'true');
      }
    }

    function currentQty() {
      return sliderToQty(parseInt(range.value, 10));
    }

    function selectTab(idx) {
      if (!sets[idx] || !sets[idx].length) return;
      tiers = sets[idx];
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-tm-tab') === String(idx);
        tabs[i].classList.toggle('is-on', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', on ? '0' : '-1');
      }
      paintBars();
      render(currentQty());
    }

    range.addEventListener('input', function () { overMax = false; render(currentQty(), 'range'); });
    range.addEventListener('change', function () { overMax = false; render(currentQty(), 'range'); });
    if (qtyInput) {
      /* Beim Klick ins Feld verschwindet die Zahl (bleibt grau als Platzhalter), man tippt direkt los;
         leer verlassen → alte Menge kommt zurück */
      var prevQty = qtyInput.value;
      qtyInput.addEventListener('focus', function () {
        prevQty = qtyInput.value || prevQty;
        qtyInput.setAttribute('placeholder', prevQty);
        qtyInput.value = '';
      });
      qtyInput.addEventListener('blur', function () {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v)) { qtyInput.value = prevQty; v = parseInt(prevQty, 10); }
        overMax = v > max;
        render(v);
      });
      qtyInput.addEventListener('input', function () {
        var v = parseInt(qtyInput.value, 10);
        if (isNaN(v)) return;
        overMax = v > max;
        if (v >= min) render(v, 'input');
      });
      qtyInput.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') { ev.preventDefault(); qtyInput.blur(); }
      });
    }
    for (var k = 0; k < bars.length; k++) {
      bars[k].addEventListener('click', function (ev) {
        overMax = false;
        render(parseInt(ev.currentTarget.getAttribute('data-tm-bar'), 10));
      });
    }
    for (var j = 0; j < tabs.length; j++) {
      tabs[j].addEventListener('click', function (ev) {
        selectTab(parseInt(ev.currentTarget.getAttribute('data-tm-tab'), 10));
      });
      /* Pfeiltasten wie bei Tabs üblich */
      tabs[j].addEventListener('keydown', function (ev) {
        if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
        var cur = parseInt(ev.currentTarget.getAttribute('data-tm-tab'), 10);
        var dir = ev.key === 'ArrowRight' ? 1 : -1;
        var nextIdx = cur;
        for (var s = 0; s < 3; s++) {
          nextIdx = ((nextIdx - 1 + dir + tabs.length) % tabs.length) + 1;
          if (sets[nextIdx] && sets[nextIdx].length) break;
        }
        var el = root.querySelector('[data-tm-tab="' + nextIdx + '"]');
        if (el) { el.focus(); selectTab(nextIdx); }
        ev.preventDefault();
      });
    }
    paintBars();
    render(qtyInput ? parseInt(qtyInput.value, 10) : currentQty());
  }

  function boot() {
    var roots = document.querySelectorAll('[data-tm-calc]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].getAttribute('data-tm-ready')) {
        roots[i].setAttribute('data-tm-ready', '1');
        init(roots[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Theme-Editor: Section wird neu geladen */
  document.addEventListener('shopify:section:load', boot);
})();
